import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";

const API_BASE = getApiBaseUrl();

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
}

export const mailLogin = async (email: string, password: string) => {
  return await fetch(`${API_BASE}/api/auth/login`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });
};

// メール確認直後はセッションが未発行でも、サービス側が Supabase Admin API で
// UID とメールの一致を検証してプロフィールを作成する。引数順は旧アプリと固定し、
// アプリ本体とローカル共有パッケージの更新タイミングがずれても互換性を維持する。
export const registAccount = async (
  supabaseUid: string,
  email: string,
  nickname: string,
  lang: string,
) => {
  return await apiFetch(`${API_BASE}/api/auth/register`, {
    method: "POST",
    // 共有API層に残っている古いトークンを自動付与しない。
    headers: { Authorization: "" },
    body: JSON.stringify({
      supabase_uid: supabaseUid,
      email,
      nickname,
      lang,
    }),
  });
};

export const logoutApi = async (accessToken: string) => {
  return await apiFetch(`${API_BASE}/api/auth/logout`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ token: accessToken }),
  });
};

export const refreshSessionApi = async (refreshToken: string) => {
  return await apiFetch<AuthResponse>(`${API_BASE}/api/auth/refresh`, {
    method: "POST",
    body: JSON.stringify({ refresh_token: refreshToken }),
  });
};
